import { Badge } from "reactstrap"

const ReversalBadge = ({ isReversal = false, isReversed = false, className = "" }) => {
  if (isReversal) {
    return <Badge color="info" className={className}>Reversal Entry</Badge>
  }

  if (isReversed) {
    return <Badge color="secondary" className={className}>Reversed</Badge>
  }

  return null
}

export default ReversalBadge
